var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-view",class:{ __hideMenuManual: _vm.hideMenuManual }},[_c('div',{staticClass:"main-view__wrapper"},[_vm._t("default")],2),(_vm.showMenu)?_c('main-navigation-bar'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }